export default __webpack_public_path__ + "static/media/bathea.65f583cb.webp";